import { render, staticRenderFns } from "./CentroTrabajoAddNew.vue?vue&type=template&id=2325b694&"
import script from "./CentroTrabajoAddNew.vue?vue&type=script&lang=js&"
export * from "./CentroTrabajoAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CentroTrabajoAddNew.vue?vue&type=style&index=0&id=2325b694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports